<div
  *ngIf="config()[value() | columnStatus] as status"
  [style.background-color]="getBackgroundColor(status.color || '')"
  [style.color]="getTextColor(status.color || '')"
  [style.border]="getBorderColor(status.color || '')"
  class="d-flex align-items-center justify-content-center fw-bold"
>
  <mat-icon *ngIf="status.icon">
    {{ status.icon }}
  </mat-icon>
  {{ status.description | translate }}
</div>
